import React from 'react';
import { TableRow, TableCell, Box } from '@mui/material';
import BondsDeptsStaticTableCell from './BondsDeptsStaticTableCell';

const BondsDeptsStaticsEmpRow = ({ data, headers }) => {
  if (Array.isArray(data) && data.length === 0) {
    return <Box>데이터가 없습니다.</Box>;
  }

  return (
    data &&
    data.map((hq, hIndex) => {
      return (
        hq?.children &&
        hq?.children.map((dp, dpIndex) => {
          return (
            dp?.children &&
            dp?.children.map((emp, empIndex) => {
              return (
                <TableRow key={emp?.id}>
                  {dpIndex === 0 &&
                    empIndex === 0 &&
                    dp.id !== 'total' &&
                    emp?.id !== 'total' && (
                      <TableCell rowSpan={hq.rowSpan} sx={{ width: '130px' }}>
                        {hq.name}
                      </TableCell>
                    )}
                  {empIndex === 0 && emp.id !== 'total' && (
                    <TableCell rowSpan={dp.rowSpan} sx={{ width: '130px' }}>
                      {dp.name}
                    </TableCell>
                  )}
                  <TableCell
                    sx={{ width: '110px' }}
                    align={emp?.id === 'total' ? 'right' : 'left'}
                    colSpan={emp?.id === 'total' ? 2 : 1}
                  >
                    {emp.name}
                  </TableCell>

                  <BondsDeptsStaticTableCell data={emp} headerRows={headers} />
                </TableRow>
              );
            })
          );
        })
      );
    })
  );
};

export default BondsDeptsStaticsEmpRow;
